module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/115-hungary-921fba0d1d58e045158b593c40260751.svg";